// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statistics-dashboard {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.statistics-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.statistics-header h1,
.statistics-panel h2,
.statistics-panel h3 {
  margin: 0;
}

.statistics-header h1 {
  color: var(--text);
  font-size: 1.2rem;
}

.statistics-panel__header p {
  margin: 4px 0 0;
  color: var(--muted);
  font-size: 0.84rem;
  font-weight: 500;
}

.statistics-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.statistics-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 8px 14px;
  border: 1px solid #1d355a;
  border-radius: 10px;
  background: #142642;
  color: #fff;
  font: inherit;
  font-size: 0.84rem;
  font-weight: 800;
  cursor: pointer;
}

.statistics-button--secondary {
  border-color: #cbd5e1;
  background: #fff;
  color: #142642;
}

.statistics-button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.statistics-header.toolbar--title .pill-btn {
  min-height: 34px;
  padding-top: 0;
  padding-bottom: 0;
}

.statistics-notice,
.statistics-state {
  padding: 14px 16px;
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  background: #eff6ff;
  color: #1e3a8a;
}

.statistics-notice--success {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #166534;
}

.statistics-notice--error,
.statistics-state--error {
  border-color: #fecaca;
  background: #fef2f2;
  color: #991b1b;
}

.statistics-state {
  min-height: 128px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.statistics-state--error {
  justify-content: flex-start;
}

.statistics-state--error p {
  margin: 4px 0 0;
}

.statistics-spinner {
  width: 22px;
  height: 22px;
  border: 3px solid #bfdbfe;
  border-top-color: #1d4ed8;
  border-radius: 50%;
  animation: statistics-spin 0.8s linear infinite;
}

@keyframes statistics-spin {
  to { transform: rotate(360deg); }
}

.statistics-runline {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  color: var(--muted);
  font-size: 0.8rem;
}

.statistics-status {
  padding: 5px 9px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475569;
  font-weight: 800;
}

.statistics-status--success {
  background: #dcfce7;
  color: #166534;
}

.statistics-status--partial {
  background: #fef3c7;
  color: #92400e;
}

.statistics-status--failed {
  background: #fee2e2;
  color: #991b1b;
}

.statistics-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.statistics-metric,
.statistics-panel {
  border: 1px solid var(--border);
  background: #fff;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);
}

.statistics-metric {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 112px;
  padding: 16px;
  border-radius: 14px;
}

.statistics-metric__icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: var(--primary-ghost);
  color: var(--primary);
}

.statistics-metric__label {
  color: var(--muted);
  font-size: 0.76rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.statistics-metric strong {
  display: block;
  margin-top: 4px;
  font-size: 1.55rem;
}

.statistics-panel {
  padding: 18px;
  border-radius: 16px;
}

.statistics-panel__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.statistics-panel__total {
  color: var(--text);
  font-size: 1.35rem;
  line-height: 1;
}

.statistics-panel h2 {
  font-size: 1.02rem;
}

.statistics-panel h3 {
  font-size: 0.94rem;
}

.statistics-chart {
  display: grid;
  grid-template-columns: repeat(24, minmax(34px, 1fr));
  gap: 7px;
  min-height: 220px;
  margin-top: 20px;
  padding-bottom: 6px;
  overflow-x: auto;
}

.statistics-chart__item {
  min-width: 34px;
  display: grid;
  grid-template-rows: 150px auto auto;
  gap: 5px;
  text-align: center;
  color: var(--muted);
  font-size: 0.68rem;
}

.statistics-chart__plot {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  border-bottom: 1px solid var(--border);
}

.statistics-chart__bar {
  width: min(28px, 70%);
  min-height: 4px;
  border-radius: 7px 7px 2px 2px;
  background: linear-gradient(180deg, #3b82f6, #1d4ed8);
}

.statistics-chart__item strong {
  color: var(--text);
}

.statistics-chart__item span {
  writing-mode: vertical-rl;
  margin: 0 auto;
}

.statistics-table td small {
  display: block;
  max-width: 500px;
  margin-top: 4px;
  overflow: hidden;
  color: var(--muted);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.statistics-table-wrap {
  width: 100%;
  margin-top: 14px;
  overflow-x: auto;
}

.statistics-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
}

.statistics-table th,
.statistics-table td {
  padding: 9px 10px;
  border-bottom: 1px solid #edf2f7;
  text-align: left;
  vertical-align: top;
}

.statistics-table th {
  background: #f8fafc;
  color: #475569;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.statistics-table code {
  color: #334155;
  font-size: 0.72rem;
  word-break: break-all;
}

.statistics-table--members {
  table-layout: fixed;
}

.statistics-table--members th:first-child,
.statistics-table--members td:first-child {
  width: 58%;
}

.statistics-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-top: 14px;
}

.statistics-pagination__page {
  color: var(--muted);
  font-size: 0.9rem;
}

.statistics-table--compact td,
.statistics-table--compact th {
  padding: 7px 8px;
}

.statistics-empty {
  color: var(--muted);
  text-align: center !important;
}

.statistics-download-types {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 16px;
}

.statistics-download-types > div,
.statistics-quality-metric,
.statistics-semantic-model {
  padding: 12px 14px;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: #f8fbff;
}

.statistics-download-types span,
.statistics-download-types strong,
.statistics-quality-metric span,
.statistics-quality-metric strong,
.statistics-semantic-model span,
.statistics-semantic-model strong {
  display: block;
}

.statistics-download-types span,
.statistics-quality-metric span,
.statistics-semantic-model span {
  color: var(--muted);
  font-size: 0.75rem;
}

.statistics-download-types strong {
  margin-top: 4px;
  font-size: 1.3rem;
}

.statistics-instance-downloads {
  margin-top: 18px;
}

.statistics-instance-downloads h3 {
  color: var(--text);
}

.statistics-instance-downloads .statistics-table-wrap {
  margin-top: 8px;
}

.statistics-quality-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.statistics-survey {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.statistics-survey__header h2 {
  margin: 0;
  color: var(--text);
  font-size: 1.02rem;
}

.statistics-survey-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  align-items: start;
}

.statistics-survey-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 14px;
}

.statistics-survey-summary > div {
  min-width: 0;
  padding: 12px;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: #f8fbff;
}

.statistics-survey-summary span,
.statistics-survey-summary strong {
  display: block;
}

.statistics-survey-summary span {
  color: var(--muted);
  font-size: 0.72rem;
}

.statistics-survey-summary strong {
  margin-top: 4px;
  color: var(--text);
  font-size: 1.2rem;
}

.statistics-quality-metric,
.statistics-semantic-model {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 14px;
}

.statistics-quality-metric + .statistics-semantic-model {
  margin-top: 10px;
}

.statistics-semantic-model--spacer {
  visibility: hidden;
}

.statistics-quality-metric strong,
.statistics-semantic-model strong {
  text-align: right;
}

@media (max-width: 1100px) {
  .statistics-metrics,
  .statistics-quality-grid,
  .statistics-survey-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .statistics-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .statistics-actions {
    justify-content: flex-start;
  }
}

@media (max-width: 720px) {
  .statistics-metrics,
  .statistics-quality-grid,
  .statistics-survey-grid,
  .statistics-download-types {
    grid-template-columns: 1fr;
  }

  .statistics-survey-summary {
    grid-template-columns: 1fr;
  }

  .statistics-actions,
  .statistics-actions .statistics-button,
  .statistics-actions .pill-btn {
    width: 100%;
  }

  .statistics-actions .statistics-button,
  .statistics-actions .pill-btn {
    justify-content: center;
  }

  .statistics-semantic-model--spacer {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StatisticsDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;;EAGE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;EAEE,+BAA+B;EAC/B,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mCAAmC;EACnC,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE;;;IAGE,gDAAgD;EAClD;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,WAAW;EACb;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".statistics-dashboard {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.statistics-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.statistics-header h1,\n.statistics-panel h2,\n.statistics-panel h3 {\n  margin: 0;\n}\n\n.statistics-header h1 {\n  color: var(--text);\n  font-size: 1.2rem;\n}\n\n.statistics-panel__header p {\n  margin: 4px 0 0;\n  color: var(--muted);\n  font-size: 0.84rem;\n  font-weight: 500;\n}\n\n.statistics-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.statistics-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 40px;\n  padding: 8px 14px;\n  border: 1px solid #1d355a;\n  border-radius: 10px;\n  background: #142642;\n  color: #fff;\n  font: inherit;\n  font-size: 0.84rem;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.statistics-button--secondary {\n  border-color: #cbd5e1;\n  background: #fff;\n  color: #142642;\n}\n\n.statistics-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.statistics-header.toolbar--title .pill-btn {\n  min-height: 34px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.statistics-notice,\n.statistics-state {\n  padding: 14px 16px;\n  border: 1px solid #bfdbfe;\n  border-radius: 12px;\n  background: #eff6ff;\n  color: #1e3a8a;\n}\n\n.statistics-notice--success {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n  color: #166534;\n}\n\n.statistics-notice--error,\n.statistics-state--error {\n  border-color: #fecaca;\n  background: #fef2f2;\n  color: #991b1b;\n}\n\n.statistics-state {\n  min-height: 128px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n\n.statistics-state--error {\n  justify-content: flex-start;\n}\n\n.statistics-state--error p {\n  margin: 4px 0 0;\n}\n\n.statistics-spinner {\n  width: 22px;\n  height: 22px;\n  border: 3px solid #bfdbfe;\n  border-top-color: #1d4ed8;\n  border-radius: 50%;\n  animation: statistics-spin 0.8s linear infinite;\n}\n\n@keyframes statistics-spin {\n  to { transform: rotate(360deg); }\n}\n\n.statistics-runline {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 16px;\n  color: var(--muted);\n  font-size: 0.8rem;\n}\n\n.statistics-status {\n  padding: 5px 9px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #475569;\n  font-weight: 800;\n}\n\n.statistics-status--success {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.statistics-status--partial {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.statistics-status--failed {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.statistics-metrics {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.statistics-metric,\n.statistics-panel {\n  border: 1px solid var(--border);\n  background: #fff;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);\n}\n\n.statistics-metric {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 112px;\n  padding: 16px;\n  border-radius: 14px;\n}\n\n.statistics-metric__icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  background: var(--primary-ghost);\n  color: var(--primary);\n}\n\n.statistics-metric__label {\n  color: var(--muted);\n  font-size: 0.76rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.statistics-metric strong {\n  display: block;\n  margin-top: 4px;\n  font-size: 1.55rem;\n}\n\n.statistics-panel {\n  padding: 18px;\n  border-radius: 16px;\n}\n\n.statistics-panel__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.statistics-panel__total {\n  color: var(--text);\n  font-size: 1.35rem;\n  line-height: 1;\n}\n\n.statistics-panel h2 {\n  font-size: 1.02rem;\n}\n\n.statistics-panel h3 {\n  font-size: 0.94rem;\n}\n\n.statistics-chart {\n  display: grid;\n  grid-template-columns: repeat(24, minmax(34px, 1fr));\n  gap: 7px;\n  min-height: 220px;\n  margin-top: 20px;\n  padding-bottom: 6px;\n  overflow-x: auto;\n}\n\n.statistics-chart__item {\n  min-width: 34px;\n  display: grid;\n  grid-template-rows: 150px auto auto;\n  gap: 5px;\n  text-align: center;\n  color: var(--muted);\n  font-size: 0.68rem;\n}\n\n.statistics-chart__plot {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  border-bottom: 1px solid var(--border);\n}\n\n.statistics-chart__bar {\n  width: min(28px, 70%);\n  min-height: 4px;\n  border-radius: 7px 7px 2px 2px;\n  background: linear-gradient(180deg, #3b82f6, #1d4ed8);\n}\n\n.statistics-chart__item strong {\n  color: var(--text);\n}\n\n.statistics-chart__item span {\n  writing-mode: vertical-rl;\n  margin: 0 auto;\n}\n\n.statistics-table td small {\n  display: block;\n  max-width: 500px;\n  margin-top: 4px;\n  overflow: hidden;\n  color: var(--muted);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.statistics-table-wrap {\n  width: 100%;\n  margin-top: 14px;\n  overflow-x: auto;\n}\n\n.statistics-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8rem;\n}\n\n.statistics-table th,\n.statistics-table td {\n  padding: 9px 10px;\n  border-bottom: 1px solid #edf2f7;\n  text-align: left;\n  vertical-align: top;\n}\n\n.statistics-table th {\n  background: #f8fafc;\n  color: #475569;\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.statistics-table code {\n  color: #334155;\n  font-size: 0.72rem;\n  word-break: break-all;\n}\n\n.statistics-table--members {\n  table-layout: fixed;\n}\n\n.statistics-table--members th:first-child,\n.statistics-table--members td:first-child {\n  width: 58%;\n}\n\n.statistics-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 14px;\n}\n\n.statistics-pagination__page {\n  color: var(--muted);\n  font-size: 0.9rem;\n}\n\n.statistics-table--compact td,\n.statistics-table--compact th {\n  padding: 7px 8px;\n}\n\n.statistics-empty {\n  color: var(--muted);\n  text-align: center !important;\n}\n\n.statistics-download-types {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  margin-top: 16px;\n}\n\n.statistics-download-types > div,\n.statistics-quality-metric,\n.statistics-semantic-model {\n  padding: 12px 14px;\n  border: 1px solid #dbeafe;\n  border-radius: 10px;\n  background: #f8fbff;\n}\n\n.statistics-download-types span,\n.statistics-download-types strong,\n.statistics-quality-metric span,\n.statistics-quality-metric strong,\n.statistics-semantic-model span,\n.statistics-semantic-model strong {\n  display: block;\n}\n\n.statistics-download-types span,\n.statistics-quality-metric span,\n.statistics-semantic-model span {\n  color: var(--muted);\n  font-size: 0.75rem;\n}\n\n.statistics-download-types strong {\n  margin-top: 4px;\n  font-size: 1.3rem;\n}\n\n.statistics-instance-downloads {\n  margin-top: 18px;\n}\n\n.statistics-instance-downloads h3 {\n  color: var(--text);\n}\n\n.statistics-instance-downloads .statistics-table-wrap {\n  margin-top: 8px;\n}\n\n.statistics-quality-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.statistics-survey {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.statistics-survey__header h2 {\n  margin: 0;\n  color: var(--text);\n  font-size: 1.02rem;\n}\n\n.statistics-survey-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  align-items: start;\n}\n\n.statistics-survey-summary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.statistics-survey-summary > div {\n  min-width: 0;\n  padding: 12px;\n  border: 1px solid #dbeafe;\n  border-radius: 10px;\n  background: #f8fbff;\n}\n\n.statistics-survey-summary span,\n.statistics-survey-summary strong {\n  display: block;\n}\n\n.statistics-survey-summary span {\n  color: var(--muted);\n  font-size: 0.72rem;\n}\n\n.statistics-survey-summary strong {\n  margin-top: 4px;\n  color: var(--text);\n  font-size: 1.2rem;\n}\n\n.statistics-quality-metric,\n.statistics-semantic-model {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.statistics-quality-metric + .statistics-semantic-model {\n  margin-top: 10px;\n}\n\n.statistics-semantic-model--spacer {\n  visibility: hidden;\n}\n\n.statistics-quality-metric strong,\n.statistics-semantic-model strong {\n  text-align: right;\n}\n\n@media (max-width: 1100px) {\n  .statistics-metrics,\n  .statistics-quality-grid,\n  .statistics-survey-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .statistics-header {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .statistics-actions {\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 720px) {\n  .statistics-metrics,\n  .statistics-quality-grid,\n  .statistics-survey-grid,\n  .statistics-download-types {\n    grid-template-columns: 1fr;\n  }\n\n  .statistics-survey-summary {\n    grid-template-columns: 1fr;\n  }\n\n  .statistics-actions,\n  .statistics-actions .statistics-button,\n  .statistics-actions .pill-btn {\n    width: 100%;\n  }\n\n  .statistics-actions .statistics-button,\n  .statistics-actions .pill-btn {\n    justify-content: center;\n  }\n\n  .statistics-semantic-model--spacer {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
